import React, { useState } from 'react';
import { db } from '../../firebase/config';
import { collection, addDoc } from 'firebase/firestore';
import '../tests/TestEditor.css'; // Reusing existing modal styles

const LessonTestBuilder = ({ onClose }) => {
  const [formData, setFormData] = useState({
    lessonTitle: '',
    levelId: '',
    maxQuestions: 10,
    lessonUrl: ''
  });
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.lessonTitle.trim()) {
      alert('Please enter a lesson title');
      return;
    }

    if (!formData.levelId) {
      alert('Please select a level');
      return;
    }

    if (!formData.lessonUrl.trim()) {
      alert('Please enter a lesson URL');
      return;
    }

    if (formData.maxQuestions < 1) {
      alert('Maximum questions must be at least 1');
      return;
    }

    try {
      setSaving(true);
      await addDoc(collection(db, 'lessonTests'), {
        lessonTitle: formData.lessonTitle.trim(),
        lessonUrl: formData.lessonUrl.trim(),
        levelId: formData.levelId,
        maxQuestions: parseInt(formData.maxQuestions),
        questions: [],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      });

      alert('Lesson test created successfully! You can now add questions to it.');
      onClose();
    } catch (error) {
      console.error('Error creating lesson test:', error);
      alert('Failed to create lesson test');
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="test-editor-overlay">
      <div className="test-editor-modal">
        <div className="builder-header">
          <h2>Create Lesson Test</h2>
          <button className="close-icon-btn" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="builder-form">
          <div className="form-group">
            <label htmlFor="lessonTitle">
              Lesson Title <span className="required">*</span>
            </label>
            <input
              id="lessonTitle"
              type="text"
              value={formData.lessonTitle}
              onChange={(e) => handleChange('lessonTitle', e.target.value)}
              placeholder="e.g., Introduction to Grammar"
              required
            />
            <small>Enter the name of the lesson this test is for</small>
          </div>

          <div className="form-group">
            <label htmlFor="lessonUrl">
              Lesson URL <span className="required">*</span>
            </label>
            <input
              id="lessonUrl"
              type="url"
              value={formData.lessonUrl}
              onChange={(e) => handleChange('lessonUrl', e.target.value)}
              placeholder="e.g., https://learn.litvill.com/learn/lesson/1xhIpsXME4T2lnTYl0py"
              required
            />
            <small>Link to the lesson students can practice after taking the test</small>
          </div>

          <div className="form-group">
            <label htmlFor="levelId">
              Level <span className="required">*</span>
            </label>
            <select
              id="levelId"
              value={formData.levelId}
              onChange={(e) => handleChange('levelId', e.target.value)}
              required
            >
              <option value="">Select a level</option>
              <option value="level-1">Level 1 - Roots</option>
              <option value="level-2">Level 2 - Branches</option>
              <option value="level-3">Level 3 - Skies</option>
              <option value="level-4">Level 4 - Rivers</option>
            </select>
            <small>Choose the level this lesson belongs to</small>
          </div>

          <div className="form-group">
            <label htmlFor="maxQuestions">
              Number of Questions to Display <span className="required">*</span>
            </label>
            <input
              id="maxQuestions"
              type="number"
              min="1"
              max="50"
              value={formData.maxQuestions}
              onChange={(e) => handleChange('maxQuestions', e.target.value)}
              required
            />
            <small>
              <strong>How randomization works:</strong> If you add 15 questions and set this to 10, 
              students will see 10 randomly selected questions each time they take the test.
            </small>
          </div>

          <div className="info-box">
            <strong>What happens next?</strong>
            <ul>
              <li>After creating the test, you can add questions to build your question pool</li>
              <li>You can add more questions than the display number (recommended for variety)</li>
              <li>When students take the test, questions are randomly selected from your pool</li>
              <li>You can manage (add/remove) questions at any time</li>
            </ul>
          </div>

          <div className="form-actions">
            <button 
              type="button" 
              onClick={onClose} 
              className="cancel-btn"
              disabled={saving}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="create-btn"
              disabled={saving}
            >
              {saving ? 'Creating...' : 'Create Test'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LessonTestBuilder;